<template>
    <div id="ProgramChildMapperList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Sub Program </div>
                    <div class="web-action-btn">
                        <div class="btn-groups">
                            <router-link class="btn btn-secondary" v-bind:to="{name: 'ProgramList'}" > <i class="fp-back"> </i> Back</router-link>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content program-asset-list">
                        <div class="form-row section-divider">
                            <div class="col col-md-3 form-group">
                                <label class="control-label" for="customer_id">Program:</label>
                                <v-select v-model="program_id" name="program_id" id="program_id" label="text" :filterable="false" :options="programArr" @search="onSearchProgram" placeholder="Select Program" class='custom-ci-auto-search close-remove'>
                                    <template slot="no-options">
                                        Search Program...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                </v-select>
                                <div class="field-error">{{ program_error_msg }}</div>
                            </div>
                                <div class="btn-groups mt-4">
                                    <button id="addProgramChild" v-on:click.prevent="programChildAdd" class="btn btn-primary">Add</button>
                                </div>
                        </div>
                        <data-table-filter-config :moduleName="'programChildList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'programChildList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listProgramChildTable"
                                    mode="remote"
                                    title="Program Child"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <template v-if="canUpdateProgram">
                                                    <!-- <router-link title="Edit Program" class="fp-edit" v-bind:to="{name: 'ProgramEdit',params:{id:props.row.id}}"></router-link> -->
                                                </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <!-- <button id="addAssetBtn" v-on:click.prevent="addAsset('asset')" class="btn btn-primary">Add Asset</button> -->
                                        <!-- <button id="addAssetBtn" v-on:click.prevent="addAsset('group')" class="btn btn-primary">Add Asset Group</button> -->
                                        <button id="deleteProgramAssetBtn" v-on:click.prevent="programChildDelete" class="btn btn-danger">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from "././event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ProgramChildList",
        metaInfo() {
            return {title: "Program Child List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                 {
                    label: 'Program',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Description',
                    field: 'description',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Start Date',
                    field: 'start_date',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Start Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'End Date',
                    field: 'end_date',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "End Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Type',
                    field: 'type',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

            ],
            rows: [],
            totalRecords: 0,
            term_value: false,
            loading:false,
            canUpdateProgram:false,
            canAddProgram:false,
            activeFlag:'asset',
            description:'',
            name:'',
            action:'list',
            programArr:[],
            program_id:'',
            program_error_msg:"",
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_program') {
                            self.cantAccessPage = true;
                        }
                        // if (permissions[i].name == 'delete_Program') {
                        //     self.term_value = true;
                        // }
                        if (permissions[i].name == 'add_program') {
                            self.canAddProgram = true;
                            self.canUpdateProgram = true;
                        }
                    }
                }
            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            onSearchProgram(search, loading) {
                var self = this;
                if (search.length > 1) {

                    loading(true);
                    self.searchField(loading, search, 'program');
                }
            },
            cancelAll: function (cancelAll) {
              this.$refs.listProgramAssetTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            loadList() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                var data = this.$refs['listProgramChildTable'].selectedRows;
                var selectedRows = [];

                for (var i = 0; i < data.length; i++) {
                    selectedRows.push(self.$refs['listProgramChildTable'].selectedRows[i].id)
                }
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    id:segments[3],
                    flag:self.activeFlag,
                    action:self.action,
                    selectedRows:selectedRows,
                };
                self.firstLoad = 1;
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/program-child/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                             if ( self.action == "delete" ) {
                                self.action = "list";
                                self.loadList();

                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }
                        }else{
                            self.rows = [];
                            self.totalRecords = 0;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'program-asset-list')
                    }
                });
            },

            programChildDelete() {
              var self = this;
              self.$swal({
                    title: 'Are you sure that you want to delete this Program?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      this.action = "delete";
                      this.loadList();

                    } else {
                      console.log("no");
                    }
                });
            },
            programChildAdd:function(){
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                var error = false;

                self.program_error_msg = '';
                if (self.program_id == null || !self.program_id.value){
                    self.program_error_msg = 'Program Required';
                    error = true;
                }
                if (self.program_id.value && self.program_id.value == segments[3]){
                    self.program_error_msg = 'Please select different program';
                    error = true;
                }

                if (error){
                    return;
                }
                
                var fields = {
                    id:segments[3],
                    program_id:self.program_id.value,
                };
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/program-child/add",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.program_id = '';
                            self.programArr = [];
                            self.loadList();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'program-child-list')
                    }
                });
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/ProgramChildList.vue